import { content } from "@/i18n/content";
import { useLang } from "@/i18n/language";
import { Section, SectionHeading } from "./Primitives";

export function Pathways() {
  const { lang } = useLang();
  const t = content[lang];

  return (
    <Section id="pathways" tone="surface">
      <SectionHeading eyebrow={t.pathways.eyebrow} title={t.pathways.title} lead={t.pathways.lead} />

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {t.pathways.items.map((p) => (
          <article
            key={p.index}
            className="flex flex-col rounded-xl border border-border bg-background p-7 transition-colors hover:border-primary/50"
            style={{ boxShadow: "var(--shadow-lift)" }}
          >
            <div className="flex items-baseline justify-between">
              <span className="text-4xl font-bold text-primary/25">{p.index}</span>
              <span className="eyebrow rounded-full border border-primary/40 px-3 py-1 text-primary">
                {p.level}
              </span>
            </div>

            <h3 className="mt-6 text-xl font-semibold">{p.title}</h3>
            <p className="mt-1 font-serif text-lg text-primary">{p.work}</p>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{p.description}</p>

            <ul className="mt-5 space-y-2.5 text-sm">
              {p.bullets.map((b) => (
                <li key={b} className="flex gap-2.5 text-muted-foreground">
                  <span className="mt-1.5 size-1.5 shrink-0 rounded-full bg-primary" />
                  {b}
                </li>
              ))}
            </ul>

            <dl className="mt-7 space-y-2 border-t border-border pt-5 text-sm">
              <div className="flex items-baseline justify-between gap-3">
                <dt className="text-muted-foreground">{t.pathways.priceLabel}</dt>
                <dd className="text-base font-semibold text-foreground">{p.price}</dd>
              </div>
              <div className="flex items-baseline justify-between gap-3">
                <dt className="text-muted-foreground">{t.pathways.seatsLabel}</dt>
                <dd>{p.seats}</dd>
              </div>
              <div className="flex items-baseline justify-between gap-3">
                <dt className="text-muted-foreground">{t.pathways.durationLabel}</dt>
                <dd>{p.duration}</dd>
              </div>
            </dl>

            <a
              href="#enroll"
              className="mt-7 rounded-full border border-primary/50 px-5 py-2.5 text-center text-sm font-semibold text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
            >
              {t.cta.apply}
            </a>
          </article>
        ))}
      </div>

      <p className="mt-8 max-w-3xl text-xs leading-relaxed text-muted-foreground">{t.pathways.note}</p>
    </Section>
  );
}
